export function renderPOBarcodeTSPL(items, cfg) {
  const lines = [];
  const W = cfg.label_width_mm || 50;
  const H = cfg.label_height_mm || 30;
  const LEFT_MM = cfg.label_margin_mm || 4;   // ~4mm left margin
  const LEFT = LEFT_MM * 8;
  const TOP = ((H * 8) - 100) / 2;

  const ascii = (s) => String(s || '').replace(/[^\x20-\x7E]/g, '');
  const short = (s, n) => ascii(s).substring(0, n);

  const MAX_CHARS_PER_LINE = Math.floor((W * 8 - LEFT) / 11);

  const splitTwoLines = (text) => {
    const clean = String(text || '').replace(/[^\x20-\x7E]/g, '');

    if (clean.length <= MAX_CHARS_PER_LINE) {
        return [clean, null];
    }

    return [
        clean.substring(0, MAX_CHARS_PER_LINE),
        clean.substring(MAX_CHARS_PER_LINE, MAX_CHARS_PER_LINE * 2),
    ];
  };

  items.forEach(item => {
    const value =
      cfg.po_barcode_value === 'product_code'
        ? item.product_code
        : item.batch_number;

    const code = short(value, 100);
    const [nameLine1, nameLine2] = splitTwoLines(item.product_name);
    const copies =
        typeof item.copies === 'number'
            ? item.copies
            : (cfg.po_barcode_copies || 1);

    for (let i = 0; i < copies; i++) {
      lines.push(`SIZE ${W} mm, ${H} mm`);
      lines.push(`GAP 2 mm,0`);
      lines.push(`DIRECTION 1`);
      lines.push(`CLS`);

      // Product name
      lines.push(`TEXT ${LEFT},${TOP},"1",0,1,1,"${nameLine1}"`);
      if (nameLine2) {
        lines.push(`TEXT ${LEFT},${TOP + 14},"1",0,1,1,"${nameLine2}"`);
      }
      const BARCODE_Y = TOP + (nameLine2 ? 32 : 18);
      // Barcode (safe density for 50mm)
      lines.push(
            `BARCODE ${LEFT},${BARCODE_Y},"128",50,1,0,1,1,"${code}"`
        );

      lines.push(`PRINT 1,1`);
    }
  });
  lines.push('SET CUTTER ON');
  lines.push('CUT');
  lines.push('CLS');
  
  return lines.join('\n');
}
